import { readItems } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { queryKeysFactory } from '../../lib/queryKeysFactory.ts';
import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useContent = (locale: string | null) => {
  return useQuery({
    // staleTime: 60 * (60 * 1000), // 60 mins
    queryKey: queryKeysFactory('content').list(locale ? [locale] : []),
    queryFn: async () => {
      if (!locale) {
        return null;
      }

      const [signup] = await directusClient.request(
        readItems('content_signup_translations', {
          fields: ['*'],
          filter: {
            languages_code: {
              _eq: locale,
            },
          },
        }),
      );

      const [login] = await directusClient.request(
        readItems('content_login_translations', {
          fields: ['*'],
          filter: {
            languages_code: {
              _eq: locale,
            },
          },
        }),
      );

      return { signup, login };
    },
  });
};
